module.exports = __webpack_public_path__ + "img/03_sub_uk.84bc8107.svg";